<template>
  <div
    class="q-px-xs q-py-xs flex q-gutter-sm"
  >
    <q-checkbox
      v-model="attrs.WITH_OPERATOR"
      size="sm"
    >
      <div class="s-font-xs">Перезвонить вам для подтверждения</div>
    </q-checkbox>
  </div>
</template>

<script lang="ts" setup>

import CommentDialog from "@/components/Shop/VOrder/ui/Dialog/Comment.vue";
import {VOrderSectionProps, vorderSectionPropsDefault} from "./util";
import Wrapper from "./Wrapper/Wrapper.vue";
import {storeToRefs} from "pinia";
import {useStackRouter} from "@/packages/stack-router/hooks/useStackRouter";
import {ICONS} from "@/assets/icons";
import {useVorderState} from "@/modules/shop/store/vorder-state";

const vorderState = useVorderState()
const {attrs} = storeToRefs(vorderState)

const props = withDefaults(defineProps<VOrderSectionProps>(), {
  ...vorderSectionPropsDefault,
})

const stackRouter = useStackRouter()

const onClick = () => {
  stackRouter.getStack()?.push(CommentDialog, {role: 'vorder'})
}

</script>

<style scoped>

.c-view {
  display: table;
  table-layout: fixed;
  width: 100%;

  div {
    display: table-cell;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
